import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

export default class TooltipShadow extends React.Component {
  static propTypes = {
    dx: PropTypes.number,
    dy: PropTypes.number,
    stdDeviation: PropTypes.number,
  };

  static defaultProps = {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
  };

  static ID = 'tooltipShadow';

  render() {
    return (
      <defs>
        <filter className={styles.TooltipShadow} id={TooltipShadow.ID}>
          <feDropShadow
            dx={this.props.dx}
            dy={this.props.dy}
            stdDeviation={this.props.stdDeviation}
          />
        </filter>
      </defs>
    );
  }
}
